import { colorTokens } from '@zing/shared/assets/theme/tokens'
import { TenantOverride } from '../../../../shared/src/assets/theme/types'

export const theme: TenantOverride = {
  colors: {
    primary:      colorTokens.blue400,
    primaryLight: colorTokens.blue950,
    primaryDark:  colorTokens.blue950,
    sidebarBackground: colorTokens.blue950,
    authGradient: `linear-gradient(90deg, ${colorTokens.white} 0%, ${colorTokens.blue400} 100%)`,
    selectHover:  colorTokens.blue100,
  },
}

